var thumbnailFilter = {};
thumbnailFilter.init = function () {
  var $thumbnailFilterSection = $('.thumbnail-filter');
  if ($thumbnailFilterSection.length > 0) {
    $.each($thumbnailFilterSection, function () {
      var $this = $(this);
      var $thumbnailFilter = $this.find('.js-thumbnail-filter-grid').isotope({
        itemSelector: '.thumbnail-filter-item',
        layoutMode: 'fitRows',
        transitionDuration: '1s'
      });
      $this.find('.filter-wrapper').on('click', 'button', function () {
        var filterValue = $(this).attr('data-filter');
        $this.find('.filter-wrapper .btn').removeClass('is-active');
        $(this).addClass('is-active');
        $(this).closest('.thumbnail-filter').find('.filter-label').text($(this).text());
        $thumbnailFilter.isotope({
          filter: filterValue
        });
      });
    });
  }
};
thumbnailFilter.init();


// WEBPACK FOOTER //
// ./scripts/components/thumbnail-filter.js